import {Directive, TemplateRef} from '@angular/core';

@Directive({
    selector: '[ostsoMultiSelectItem]',
    standalone: true
})
export class MultiSelectItemDirective<T = any> {

    constructor(public template: TemplateRef<T>) {
    }

}
